import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/common/Button";

const GalleryList = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h2 style={styles.heading}>Gallery</h2>
      <div style={styles.card}>
        <div style={styles.icon}>🖼️</div>
        <p style={styles.text}>
          Galleries are organized by event. Open an event to browse its galleries and albums.
        </p>
        <Button onClick={() => navigate("/events")}>Go to Events</Button>
      </div>
    </div>
  );
};

const styles = {
  heading: { margin: "0 0 24px", fontSize: 22, fontWeight: 700, color: "#1e1e2d" },
  card: {
    background: "#fff",
    borderRadius: 14,
    padding: "40px 32px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    maxWidth: 440,
    textAlign: "center",
  },
  icon: { fontSize: 48, marginBottom: 16 },
  text: { color: "#666", fontSize: 15, marginBottom: 24, lineHeight: 1.6 },
};

export default GalleryList;
